import React from 'react'
import { config } from '../../../../config.js';
import TransactionRow from '../TransactionRow.js';
import moment from 'moment';
import './PaymentHistory.scss';
import { BigDecimal } from 'bigdecimal';

const PaymentHistory = ({status, sentAmount, amountLeftToPay, transactions = []}) => {
    const amountLeftToPayIsNegative = new BigDecimal("0").compareTo(new BigDecimal(amountLeftToPay)) > -1;
   
    return (
        <div className={`payment-history-component`}>
            {transactions.length > 0 && <> 
                <h2 className="payment-history-component--title">{config.currencies.ADA.symbol} transactions history</h2>
                <div className="payment-history-component--transactions">
                    {transactions
                    .sort(({createTime: currentDate}, {createTime: nextDate}) => moment.utc(nextDate).valueOf() - moment.utc(currentDate).valueOf())
                    .map(({status, amount, lastMonitoredDepth, createTime, transactionHash}) => 
                        <TransactionRow 
                            key={transactionHash} 
                            address={transactionHash}
                            status={status} 
                            amount={amount}
                            date={createTime}
                            confirmation={[
                                lastMonitoredDepth > config.transaction.maxMonitoredDepth ? config.transaction.maxMonitoredDepth : lastMonitoredDepth, 
                                config.transaction.maxMonitoredDepth
                            ]}
                        />)}
                </div>
            </>}
            
            {(status !== config.statuses.confirmed && status !== config.statuses.payment_sent) && <> 
                <div className="payment-history-component--row">
                    <h2 className="payment-history-component--row-title">Total amount sent</h2>
                    <b className="payment-history-component--row-amount">{sentAmount} {config.currencies.ADA.symbol}</b>
                </div> 
                
                <div className="payment-history-component--row">
                    <h2 className="payment-history-component--row-title">Amount left to pay</h2>
                    <b className="payment-history-component--row-amount">{amountLeftToPayIsNegative ? "0" : amountLeftToPay} {config.currencies.ADA.symbol}</b>
                </div>
            </>}
        </div>
    )
}

export default PaymentHistory;